import { angehoerigePages } from "~/domains/nachlass/erbschein/anfrage/angehoerige/pages";
import { antragstellendePersonPages } from "~/domains/nachlass/erbschein/anfrage/antragstellende-person/pages";
import { ehepartnerPages } from "~/domains/nachlass/erbschein/anfrage/ehepartner/pages";
import { nachlassPages } from "~/domains/nachlass/erbschein/anfrage/nachlass/pages";
import { testamentOderErbvertragPages } from "~/domains/nachlass/erbschein/anfrage/testament-oder-erbvertrag/pages";
import { verstorbenePersonPages } from "~/domains/nachlass/erbschein/anfrage/verstorbene-person/pages";
import { type PageConfigMap } from "~/services/flow/flowEngine/types";
import { schemaOrEmptyString } from "~/services/validation/schemaOrEmptyString";
import { stringOptionalSchema } from "~/services/validation/stringOptional";

export const erbscheinAnfragePages = {
  start: {
    stepId: "/start",
  },
  ...verstorbenePersonPages,
  ...antragstellendePersonPages,
  ...testamentOderErbvertragPages,
  ...ehepartnerPages,
  ...angehoerigePages,
  ...nachlassPages,
  weitereAngaben: {
    stepId: "/abgabe/weitere-angaben",
    pageSchema: {
      weitereAngaben: schemaOrEmptyString(stringOptionalSchema),
    },
  },
  abgabe: {
    stepId: "/abgabe/zusammenfassung",
  },
  ende: {
    stepId: "/abgabe/ende",
  },
} as const satisfies PageConfigMap;

export type ErbscheinAnfragePages = typeof erbscheinAnfragePages;
